/*=========================================================================================
  File Name: moduleSurgeryItemMutations.js
  Description: SurgeryItem Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ADD_ITEM(state, item) {
    state.surgeryItems.unshift(item)
  },
  SET_SurgeryItem(state, surgeryItems) {
    state.surgeryItems = surgeryItems
  },
  UPDATE_SurgeryItem(state, SurgeryItem) {
    const SurgeryItemIndex = state.surgeryItems.findIndex((p) => p.ID == SurgeryItem.ID)
    Object.assign(state.surgeryItems[SurgeryItemIndex], SurgeryItem)
},
REMOVE_ITEM(state, itemId) {
    const ItemIndex = state.surgeryItems.findIndex((p) => p.ID == itemId)
    state.surgeryItems.splice(ItemIndex, 1)
},
}
